export default "__VITE_ASSET__BismBC8w__"